import React, { useEffect, useCallback } from 'react';
import { useThree } from '@react-three/fiber';

import useAnimationStore from '../../../../../common/store/useAnimationStore';
import useTriggerStore from '../../../../../common/store/useTriggerStore';

type FallAnimationProps = {
  ref: React.RefObject<THREE.Group>,
  target: number
}

const useFallAnimation = (
  uno: FallAnimationProps,
  dos: FallAnimationProps
) => {
  const camera: THREE.PerspectiveCamera = useThree(useCallback(state => state.camera, []));
  const fall = useAnimationStore(useCallback(state => state.landing.webgl.fall, []));
  const set = useTriggerStore(useCallback(state => state.set, []));

  useEffect(() => {
    const ease = "power2.inOut";

    fall.fromTo(uno.ref.current!.position, { y: 5 }, { duration: 3.5, ease, y: uno.target });
    fall.fromTo(dos.ref.current!.position, { y: 5 }, { duration: 3.3, ease, y: dos.target }, "<+=0.2");
    fall.to(camera.position, { duration: 2.8, ease, y: -10 }, 0.7);

    fall.eventCallback("onComplete", () => set("appleFall", true));

    return () => {
      fall.clear();
      set("appleFall", false);
    }
  }, []);
}

export default useFallAnimation;